export function initMatrix(length = 0) {
  return Array.from({ length }).map(() => Array.from({ length }).fill(0));
}
